const HaloPSAUsersImport = () => import('@/views/account/integrations/halopsa/import/halopsa-users-import-view.vue');
const HaloPSACompaniesImport = () => import('@/views/account/integrations/halopsa/import/halopsa-companies-import-view.vue');
const HaloPSAContactsImport = () => import('@/views/account/integrations/halopsa/import/halopsa-contacts-import-view');
const HaloPSAActivitiesImport = () => import('@/views/account/integrations/halopsa/import/halopsa-activities-import-view');
const HaloPSAOpportunitiesImport = () => import('@/views/account/integrations/halopsa/import/halopsa-opportunities-import-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/HaloPSA/Manage/Users/Import',
        name: 'HaloPSAUsersImport',
        component: HaloPSAUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Users/Import',
        name: 'ClientHaloPSAUsersImport',
        component: HaloPSAUsersImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Companies/Import',
        name: 'HaloPSACompaniesImport',
        component: HaloPSACompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Companies/Import',
        name: 'ClientHaloPSACompaniesImport',
        component: HaloPSACompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Contacts/Import',
        name: 'HaloPSAContactsImport',
        component: HaloPSAContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Contacts/Import',
        name: 'ClientHaloPSAContactsImport',
        component: HaloPSAContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Activities/Import',
        name: 'HaloPSAActivitiesImport',
        component: HaloPSAActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Activities/Import',
        name: 'ClientHaloPSAActivitiesImport',
        component: HaloPSAActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HaloPSA/Manage/Opportunities/Import',
        name: 'HaloPSAOpportunitiesImport',
        component: HaloPSAOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HaloPSA/Manage/Opportunities/Import',
        name: 'ClientConnectWiseOpportunitiesImport',
        component: HaloPSAOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    }
]